import { create } from 'zustand';
import { getFromSessionStorage } from '@/lib/helper';

interface HomeStore {
  isActiveRequest: boolean;
  timerExpired: boolean;
  otpTokenLength:number;
  expiredAt: number | undefined;
  setExpiredAt: (arg: number) => void;
  setTimerExpired: (arg: boolean) => void;
  invoice: number;
  remainInvoice: number;
  setInvoice: (arg: number) => void;
  setRemainInvoice: (arg: number) => void;
  setIsActiveRequest: (arg: boolean) => void;
  setOtpTokenLength: (arg: number) => void;
  isActiveEditWallets: boolean;
  setIsActiveEditWallets: (arg: boolean) => void;
}

const useHomeStore = create<HomeStore>((set) => ({
  timerExpired: false,
  isActiveRequest: false,
  otpTokenLength: 5,
  expiredAt: undefined,
  invoice: 0 ,
  remainInvoice: 0,
  isActiveEditWallets: !!getFromSessionStorage('editableWallets'),
  setExpiredAt: (arg: number) => set({ expiredAt: arg }),
  setTimerExpired: (arg: boolean) => set({ timerExpired: arg }),
  setInvoice: (arg: number) => set({ invoice: arg }),
  setRemainInvoice: (arg: number) => set({ remainInvoice: arg }),
  setIsActiveRequest: (arg: boolean) => set({ isActiveRequest: arg }),
  setOtpTokenLength: (arg: number) => set({ otpTokenLength: arg }),
  setIsActiveEditWallets: (arg: boolean) => set({ isActiveEditWallets: arg }),
}));
export default useHomeStore;
